<template>
  <BaseTemplate app-name="Medical System" page-title="">
    <template #content>
      <div
        class="h-screen flex flex-col bg-gray-50 dark:bg-gray-900 text-gray-800 dark:text-gray-100 transition-colors duration-200"
      >
      
        <!-- Main Content -->
        <div class="flex-1 flex overflow-hidden">
          
          <!-- Content Area -->
          <div class="flex-1 overflow-hidden flex flex-col">
            <!-- Header -->
            <div class="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-4 shadow-sm">
              <div class="flex flex-wrap justify-between items-center gap-4">
                <div class="flex items-center gap-3">
                  <h2 class="text-xl font-medium">{{ currentView === 'list' ? 'Pacientes' : 'Cadastro de Paciente' }}</h2>
                  <button
                    v-if="currentView === 'form'"
                    class="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
                    @click="goToList"
                    aria-label="Voltar para lista"
                  >
                    <ArrowLeftIcon class="w-5 h-5" />
                  </button>
                </div>
                <div class="flex items-center gap-2">
                  <button
                    v-if="currentView === 'list'"
                    class="px-4 py-2 clinic-btn text-white rounded-md transition-colors shadow-sm flex items-center gap-2"
                    @click="openNewPatientForm"
                  >
                    <PlusIcon class="w-4 h-4" />
                    <span>Novo Paciente</span>
                  </button>
                  <button
                    v-if="currentView === 'list' && canMergePatient"
                    class="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md transition-colors shadow-sm flex items-center gap-2"
                    @click="openMergeModal"
                  >
                    <UsersIcon class="w-4 h-4" />
                    <span>Juntar Pacientes</span>
                  </button>

                <!--  <button
                    v-if="currentView === 'list'"
                    class="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md transition-colors shadow-sm flex items-center gap-2"
                    @click="syncAllPatients"
                    :disabled="isSyncingAll"
                  >
                    <RefreshCwIcon class="w-4 h-4" :class="{ 'animate-spin': isSyncingAll }" />
                    <span>{{ isSyncingAll ? 'Sincronizando...' : 'Sincronizar Todos' }}</span>
                  </button> -->
                  <button
                    v-if="currentView === 'form'"
                    class="px-4 py-2 clinic-btn text-white rounded-md transition-colors shadow-sm flex items-center gap-2"
                    @click="savePatient"
                    :disabled="!isFormValid"
                  >
                    <SaveIcon class="w-4 h-4" />
                    <span>{{ editMode ? 'Atualizar' : 'Salvar' }} Paciente</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- Patient List View -->
             
            <div v-if="currentView === 'list'" class="flex-1 overflow-y-auto p-4 bg-gray-50 dark:bg-gray-900">
              <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-300 dark:border-gray-700 p-4">
                <!-- Search and Filter -->
                <div class="mb-4 flex flex-wrap gap-4">
                  <div class="flex-1 min-w-[240px]">
                    <div class="relative">
                      <input
                        type="text"
                        v-model="searchQuery"
                        placeholder="Buscar pacientes..."
                        class="w-full px-3 py-2 pl-10 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                      />
                      <SearchIcon class="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
                    </div>
                  </div>
                  <div class="w-full md:w-auto flex gap-2">
                    <div class="relative">
                      <select
                        v-model="filterGender"
                        class="h-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent appearance-none pr-8"
                      >
                        <option value="">Todos os gêneros</option>
                        <option value="M">Masculino</option>
                        <option value="F">Feminino</option>
                        <option value="O">Outro</option>
                      </select>
                      <div class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <ChevronDownIcon class="w-4 h-4 text-gray-500" />
                      </div>
                    </div>

                    <button
                      @click="resetFilters"
                      class="px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm hover:bg-gray-50 dark:hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                    >
                      <RefreshCwIcon class="w-4 h-4" />
                    </button>
                  </div>
                </div>

                <!-- Patients Table -->
                <div class="overflow-x-auto">
                  <table class="w-full border-collapse">
                    <thead>
                      <tr class="bg-gray-50 dark:bg-gray-900/50 text-left">
                        <th class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          ID
                        </th>
                        <th class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Nome
                        </th>
                        <th class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Documento
                        </th>
                        <th class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Gênero
                        </th>
                        <th class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Data de Nascimento
                        </th>
                        <th class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Telefone
                        </th>
                        <th class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Raça
                        </th>
                        <th class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Plano de Saúde
                        </th>
                        <th class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Ações
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filteredPatients.length === 0">
                        <td colspan="9" class="px-4 py-6 text-center text-gray-500 dark:text-gray-400">
                          Nenhum paciente encontrado
                        </td>
                      </tr>
                      <tr v-for="patient in patients" :key="patient.id"
                        class="border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
                      >
                        <td class="px-4 py-3 text-sm">{{ patient.id }}</td>
                        <td class="px-4 py-3">
                          <div class="flex items-center gap-3">
                            <div
                              class="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-medium flex-shrink-0"
                              :style="{ backgroundColor: getPatientColor(patient.id) }"
                            >
                              {{ getInitials(patient.name) }}
                            </div>
                            <div class="text-sm font-medium">{{ patient.socialName || patient.name }}</div>
                          </div>
                        </td>
                        <td class="px-4 py-3 text-sm">{{ patient.documentValue }}</td>
                        <td class="px-4 py-3 text-sm">{{ getGenderLabel(patient.gender) }}</td>
                        <td class="px-4 py-3 text-sm">{{ formatDate(patient.birthdate) }}</td>
                        <td class="px-4 py-3 text-sm">{{ patient.phone }}</td>
                        <td class="px-4 py-3 text-sm">{{ getRaceLabel(patient.race) }}</td>
                        <td class="px-4 py-3 text-sm">{{ patient.healthInsurance || '-' }}</td>
                        <td class="px-4 py-3 text-sm">
                          <div class="flex gap-2">
                            <button
                              @click="editPatient(patient)"
                              class="p-1 text-gray-500 hover:text-emerald-600 dark:text-gray-400 dark:hover:text-emerald-400"
                              title="Editar"
                            >
                              <EditIcon class="w-4 h-4" />
                            </button>
                            <button
                              @click="syncPatient(patient)"
                              class="p-1 text-gray-500 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400"
                              title="Sincronizar"
                            >
                              <RefreshCwIcon class="w-4 h-4" />
                            </button>
                            <button
                              @click="resetPortalPassword(patient)"
                              class="p-1 text-gray-500 hover:text-orange-600 dark:text-gray-400 dark:hover:text-orange-400"
                              title="Resetar Senha do Portal"
                            >
                              <KeyIcon class="w-4 h-4" />
                            </button>
                            <button
                              @click="confirmDeletePatient(patient)"
                              class="p-1 text-gray-500 hover:text-red-600 dark:text-gray-400 dark:hover:text-red-400"
                              title="Excluir"
                            >
                              <TrashIcon class="w-4 h-4" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              <!-- Pagination -->
<!-- depois -->
<div class="mt-4 flex justify-between items-center">
  <div class="text-sm text-gray-500 dark:text-gray-400">
    Mostrando página {{ page }} de {{ totalPages }} (total {{ total }} pacientes)
  </div>
  <div class="flex items-center gap-4">
    <!-- dropdown de tamanho de página junto dos botões -->
    <label for="pageSize" class="text-sm text-gray-600 dark:text-gray-300">
      Itens por página:
    </label>
    <select
      id="pageSize"
      v-model="pageSize"
      @change="fetchPatients(1)"
      class="px-2 py-1 border rounded bg-white dark:bg-gray-800 text-sm"
    >
      <option :value="10">10</option>
      <option :value="20">20</option>
      <option :value="30">30</option>
    </select>
    <button
      class="px-3 py-1 border rounded-md"
      @click="goPrev"
      :disabled="page <= 1"
    >
      Anterior
    </button>
    <button
      class="px-3 py-1 border rounded-md"
      @click="goNext"
      :disabled="page >= totalPages"
    >
      Próximo
    </button>
  </div>
</div>



              </div>
            </div>



            <!-- Patient Form View with Tabs -->
            <div v-if="currentView === 'form'" class="flex-1 overflow-y-auto p-4 bg-gray-50 dark:bg-gray-900">
              <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-300 dark:border-gray-700" :style="{ color: 'var(--clinic-font-color)' }">
                <!-- Tabs Navigation -->
                <div class="border-b border-gray-200 dark:border-gray-700">
                  <div class="flex overflow-x-auto">
                    <button
                      v-for="tab in tabs"
                      :key="tab.id"
                      @click="activeTab = tab.id"
                      class="px-4 py-3 text-sm font-medium whitespace-nowrap transition-colors focus:outline-none"
                      :class="{
                        'text-emerald-600 dark:text-emerald-400 border-b-2 border-emerald-500 dark:border-emerald-400': activeTab === tab.id,
                        'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300': activeTab !== tab.id
                      }"
                      :style="{ color: 'var(--clinic-font-color)' }"
                    >
                      <div class="flex items-center gap-2">
                        <component :is="tab.icon" class="w-4 h-4" />
                        {{ tab.name }}
                      </div>
                    </button>
                  </div>
                </div>

                <!-- Tab Content -->
                <div class="p-6">
                  <!-- Personal Information Tab -->
                  <div v-if="activeTab === 'personal'" class="space-y-4">
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <!-- ID do Paciente -->
                      <div>
                        <label class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">ID do Paciente</label>
                        <div class="relative">
                          <input
                            type="text"
                            v-model="currentPatient.id"
                            placeholder="Gerado automaticamente"
                            disabled
                            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                          />
                        </div>
                      </div>

                      <!-- Nome Completo -->
                      <div class="md:col-span-2">
                        <label for="name" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Nome Completo*</label>
                        <input
                          id="name"
                          type="text"
                          v-model="currentPatient.name"
                          @input="formatName"
                          placeholder="Digite o nome completo do paciente"
                          required
                          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                        />
                      </div>

                      <!-- Nome Social -->
                      <div class="md:col-span-2">
                        <label for="socialName" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Nome Social</label>
                        <input
                          id="socialName"
                          type="text"
                          v-model="currentPatient.socialName"
                          @input="formatSocialName"
                          placeholder="Digite o nome social do paciente (opcional)"
                          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                        />
                      </div>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <!-- Data de Nascimento -->
                      <div>
                        <label for="birthdate" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Data de Nascimento*</label>
                        <input
                          id="birthdate"
                          type="date"
                          v-model="currentPatient.birthdate"
                          required
                          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                        />
                      </div>

                      <!-- Gênero -->
                      <div>
                        <label for="gender" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Gênero*</label>
                        <div class="relative">
                          <select
                            id="gender"
                            v-model="currentPatient.gender"
                            required
                            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent appearance-none pr-8"
                          >
                            <option value="">Selecione</option>
                            <option value="M">Masculino</option>
                            <option value="F">Feminino</option>
                            <option value="O">Outro</option>
                          </select>
                          <div class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                            <ChevronDownIcon class="w-4 h-4 text-gray-500" />
                          </div>
                        </div>
                      </div>

                      <!-- Raça -->
                      <div>
                        <label for="race" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Raça</label>
                        <div class="relative">
                          <select
                            id="race"
                            v-model="currentPatient.race"
                            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent appearance-none pr-8"
                          >
                            <option value="">Selecione</option>
                            <option value="01">Branca</option>
                            <option value="02">Preta</option>
                            <option value="03">Parda</option>
                            <option value="04">Amarela</option>
                            <option value="05">Indígena</option>
                          </select>
                          <div class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                            <ChevronDownIcon class="w-4 h-4 text-gray-500" />
                          </div>
                        </div>
                      </div>

                      <!-- Tipo de Documento -->
                      <div>
                        <label for="document_type" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Tipo de Documento*</label>
                        <div class="relative">
                          <select
                            id="document_type"
                            v-model="currentPatient.documentType"
                            required
                            @change="onDocumentTypeChange"
                            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent appearance-none pr-8"
                          >
                            <option value="">Selecione</option>
                            <option value="CPF">CPF</option>
                            <option value="CNS">CNS</option>
                            <option value="GEN">Genérico</option>
                          </select>
                          <div class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                            <ChevronDownIcon class="w-4 h-4 text-gray-500" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-1 gap-4">
                      <!-- CPF ou CNS -->
                      <div>
                        <label :for="currentPatient.documentType?.toLowerCase()" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">{{ currentPatient.documentType || 'CPF/CNS' }}*</label>
                        <div class="relative">
                          <input
                            :id="currentPatient.documentType?.toLowerCase()"
                            type="text"
                            v-model="currentPatient.documentValue"
                            @input="formatDocument"
                            :placeholder="currentPatient.documentType === 'CPF' ? '000.000.000-00' : currentPatient.documentType === 'CNS' ? '000000000000000' : 'Gerado automaticamente'"
                            :disabled="currentPatient.documentType === 'GEN'"
                            required
                            :class="[
                              'w-full px-3 py-2 border rounded-md text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:border-transparent',
                              currentPatient.documentType === 'GEN' ? 'bg-gray-100 dark:bg-gray-700 border-gray-200 dark:border-gray-700' : 'bg-white dark:bg-gray-900',
                              isDocumentValid ? 'border-gray-200 dark:border-gray-700 focus:ring-emerald-500' : 'border-red-500 focus:ring-red-500'
                            ]"
                          />
                          <div v-if="currentPatient.documentType === 'CPF' && currentPatient.documentValue && !isDocumentValid" class="absolute inset-y-0 right-0 flex items-center pr-3">
                            <div class="text-red-500 text-xs">CPF Inválido</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Contact Tab -->
                  <div v-if="activeTab === 'contact'" class="space-y-4">
                    <div>
                      <label for="phone" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Telefone*</label>
                      <input
                        id="phone"
                        type="tel"
                        v-model="currentPatient.phone"
                        placeholder="(00) 00000-0000"
                        required
                        class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                      />
                    </div>
                    
                    <div>
                      <label for="email" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Email</label>
                      <input
                        id="email"
                        type="email"
                        v-model="currentPatient.email"
                        placeholder="exemplo@email.com"
                        class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                      />
                    </div>
                    
                    <div>
                      <label for="emergency-contact" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Contato de Emergência</label>
                      <input
                        id="emergency-contact"
                        type="text"
                        v-model="currentPatient.emergencyContact"
                        placeholder="Nome e telefone"
                        class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                      />
                    </div>
                  </div>

                  <!-- Address Tab -->
                  <div v-if="activeTab === 'address'" class="space-y-4">
                          <div>
                            <label for="cep" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">CEP</label>
                            <div class="flex gap-2">
                              <div class="relative flex-1">
                                <input
                                  id="cep"
                                  type="text"
                                  v-model="currentPatient.address.cep"
                                  placeholder="00000-000"
                                  @blur="lookupCep"
                                  @input="formatCep"
                                  class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                                />
                                <div v-if="isLoadingCep" class="absolute inset-y-0 right-0 flex items-center pr-3">
                                  <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-emerald-500"></div>
                                </div>
                              </div>
                              <button
                                type="button"
                                @click="lookupCep"
                                :disabled="!currentPatient.address.cep || isLoadingCep"
                                class="px-3 py-2 bg-emerald-500 hover:bg-emerald-600 disabled:bg-gray-300 text-white rounded-md transition-colors text-sm flex items-center gap-1"
                                title="Buscar endereço pelo CEP"
                              >
                                <SearchIcon class="w-4 h-4" />
                                Buscar
                              </button>
                            </div>
                          </div>
                    
                    <div>
              
                    
                    
                      <label for="logradouro-tipo" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Tipo de Logradouro</label>
                      <select
                        id="logradouro-tipo"
                        v-model="selectedLogradouroTipo"
                        @change="onLogradouroTipoChange"
                        class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent appearance-none pr-8"
                      >
                        <option value="">Selecione o tipo</option>
                        <option value="001">Acesso</option>
                        <option value="004">Alameda</option>
                        <option value="008">Avenida</option>
                        <option value="020">Conjunto</option>
                        <option value="023">Campo</option>
                        <option value="028">Distrito</option>
                        <option value="031">Estrada</option>
                        <option value="081">Rua</option>
                        <option value="090">Rodovia</option>
                        <option value="092">Sítio</option>
                        <option value="098">Terminal</option>
                        <option value="100">Travessa</option>
                        <option value="103">Viaduto</option>
                        <option value="104">Vila</option>
                        <option value="485">Condomínio</option>
                        <option value="486">Habitacional</option>
                        <option value="487">Residencial</option>
                      </select>
                    </div>
                    
                    <div>
                      <label for="logradouro-codigo" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Código do Logradouro</label>
                      <input
                        id="logradouro-codigo"
                        type="text"
                        v-model="currentPatient.address.logradouro_codigo"
                        placeholder="Código do logradouro"
                        readonly
                        class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-gray-50 dark:bg-gray-800 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                      />
                    </div>
                    
                    <div>
                      <label for="street" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Logradouro</label>
                      <input
                        id="street"
                        type="text"
                        v-model="currentPatient.address.street"
                        placeholder="Nome do logradouro"
                        class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                      />
                    </div>
                    
                    <div>
                      <label for="neighborhood" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Bairro</label>
                      <input
                        id="neighborhood"
                        type="text"
                        v-model="currentPatient.address.neighborhood"
                        placeholder="Nome do bairro"
                        class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                      />
                    </div>
                    
                    <div class="grid grid-cols-2 gap-4">
                      <div>
                        <label for="number" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Número</label>
                        <input
                          id="number"
                          type="text"
                          v-model="currentPatient.address.number"
                          placeholder="Número da residência"
                          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                        />
                      </div>
                      
                      <div>
                        <label for="complement" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Complemento</label>
                        <input
                          id="complement"
                          type="text"
                          v-model="currentPatient.address.complement"
                          placeholder="Apartamento, bloco, etc."
                          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                        />
                      </div>
                    </div>
                    
                    <div class="grid grid-cols-2 gap-4">
                      <div>
                        <label for="city" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Cidade</label>
                        <input
                          id="city"
                          type="text"
                          v-model="currentPatient.address.city"
                          placeholder="Nome da cidade"
                          @input="onCityChange"
                          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                        />
                      </div>
                      
                      <div>
                        <label for="state" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Estado</label>
                        <input
                          id="state"
                          type="text"
                          v-model="currentPatient.address.state"
                          placeholder="SP"
                          maxlength="2"
                          @input="onStateChange"
                          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                        />
                      </div>
                    </div>
                    

                  </div>

                  <!-- Medical Information Tab -->
                  <div v-if="activeTab === 'medical'" class="space-y-4">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label for="health-insurance" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Plano de Saúde</label>
                        <div class="relative">
                          <select
                            id="health-insurance"
                            v-model="currentPatient.healthInsurance"
                            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent appearance-none pr-8"
                          >
                            <option value="">Selecione um plano</option>
                            <option v-if="insurances.length === 0" value="" disabled>Carregando convênios...</option>
                            <option v-for="insurance in insurances" :key="insurance.id" :value="insurance.name">{{ insurance.name }}</option>
                          </select>
                          <div class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                            <ChevronDownIcon class="w-4 h-4 text-gray-500" />
                          </div>
                        </div>
                      </div>
                      
                      <div>
                        <label for="insurance-id" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Número da Carteirinha</label>
                        <input
                          id="insurance-id"
                          type="text"
                          v-model="currentPatient.insuranceId"
                          placeholder="Número do plano de saúde"
                          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                        />
                      </div>
                    </div>
                    
                    <div>
                      <label for="allergies" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Alergias</label>
                      <textarea
                        id="allergies"
                        v-model="currentPatient.allergies"
                        rows="2"
                        placeholder="Liste as alergias conhecidas do paciente..."
                        class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                      ></textarea>
                    </div>
                    
                    <div>
                      <label for="medical-conditions" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Condições Médicas</label>
                      <textarea
                        id="medical-conditions"
                        v-model="currentPatient.medicalConditions"
                        rows="2"
                        placeholder="Doenças crônicas, condições especiais..."
                        class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                      ></textarea>
                    </div>
                    
                    <div>
                      <label for="notes" class="block text-sm font-medium mb-1" :style="{ color: 'var(--clinic-font-color)' }">Observações</label>
                      <textarea
                        id="notes"
                        v-model="currentPatient.notes"
                        rows="3"
                        placeholder="Informações adicionais sobre o paciente..."
                        class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                      ></textarea>
                    </div>
                  </div>

                  <!-- Form Actions -->
                  <div class="mt-8 flex justify-between items-center">
                    <div class="flex gap-2">

                    </div>
                    <div class="flex gap-3">
                      <button
                        class="px-4 py-2 border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-md transition-colors"
                        @click="goToList"
                      >
                        Cancelar
                      </button>
                      <button
                        class="px-6 py-2 clinic-btn text-white rounded-md transition-colors shadow-sm disabled:bg-gray-300 dark:disabled:bg-gray-600 disabled:cursor-not-allowed"
                        @click="savePatient"
                        :disabled="!isFormValid"
                      >
                        {{ editMode ? 'Atualizar' : 'Salvar' }} Paciente
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Merge Patient Modal -->
            <MergePatientModal
              v-if="canMergePatient"
              :dialog="showMergeModal"
              :patients="allPatients"
              @close="closeMergeModal"
              @merge="handleMergePatients"
            />

            <!-- Banner Message -->
            <BannerMessage
              v-if="banner.show"
              :type="banner.type"
              :message="banner.message"
              @close="banner.show = false"
            />

            <!-- Delete Confirmation Modal -->
            <div
              class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
              v-if="showDeleteModal"
              @click.self="showDeleteModal = false"
            >
              <div
                class="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto animate-fadeIn"
              >
                <div class="p-6">
                  <div
                    class="w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center text-red-600 dark:text-red-400 mx-auto mb-4"
                  >
                    <AlertTriangleIcon class="w-8 h-8" />
                  </div>
                  <h3 class="text-xl font-medium mb-2 text-center">Confirmar Exclusão</h3>
                  <p class="text-gray-600 dark:text-gray-400 mb-6 text-center">
                    Tem certeza que deseja excluir o paciente <span class="font-medium">{{ patientToDelete?.name }}</span>?
                    <br />Esta ação não pode ser desfeita.
                  </p>
                  <div class="flex justify-end gap-3">
                    <button
                      class="px-4 py-2 border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-md transition-colors"
                      @click="showDeleteModal = false"
                    >
                      Cancelar
                    </button>
                    <button
                      class="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-md transition-colors shadow-sm"
                      @click="deletePatient"
                    >
                      Excluir
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseTemplate>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import BaseTemplate from '../templates/BaseTemplate.vue';
import BannerMessage from '@/components/BannerMessage.vue';
import MergePatientModal from '@/components/MergePatientModal.vue';
import apiClient from '@/services/authService';
import { usePermissions } from '@/composables/usePermissions';
import {
  Plus, ChevronDown, Search, Edit, Trash,
  Save, ArrowLeft, RefreshCw, AlertTriangle,
  Key,
  User, Phone, MapPin, Activity, Users
} from 'lucide-vue-next';

// — Icons —
const PlusIcon          = Plus;
const ChevronDownIcon   = ChevronDown;
const UsersIcon         = Users;

const SearchIcon        = Search;
const EditIcon          = Edit;
const TrashIcon         = Trash;
const SaveIcon          = Save;
const ArrowLeftIcon     = ArrowLeft;
const RefreshCwIcon     = RefreshCw;
const AlertTriangleIcon = AlertTriangle;
const KeyIcon           = Key;
const UserIcon          = User;
const PhoneIcon         = Phone;
const MapPinIcon        = MapPin;
const ActivityIcon      = Activity;

const { canMergePatient } = usePermissions();

const banner = ref({ show: false, type: 'success', message: '' });
const isLoadingCep = ref(false);
//const isSyncingAll = ref(false);

const total       = ref(0);
const page        = ref(1);
const pageSize = ref(10);

const totalPages = computed(() =>
  Math.ceil(total.value / pageSize.value)
);

// — Estado básico —
const currentView     = ref('list');    // 'list' ou 'form'
const showDeleteModal = ref(false);
const showMergeModal = ref(false);
const editMode        = ref(false);
const patientToDelete = ref(null);

async function openMergeModal() {
  await fetchAllPatients();
  showMergeModal.value = true;
}

function closeMergeModal() {
  showMergeModal.value = false;
}

async function handleMergePatients({ sourceId, destinationId }) {
  try {
    await apiClient.post('/api/v1/patients/merge_patients', {
      source_patient_id: sourceId,
      destination_patient_id: destinationId,
    });
    showBanner('success', 'Pacientes mesclados com sucesso!');
    fetchPatients();
    closeMergeModal();
  } catch (err) {
    console.error('Erro ao mesclar pacientes', err);
    const errorMessage = err.response?.data?.detail || err.response?.data?.message || 'Erro desconhecido';
    showBanner('error', errorMessage);
  }
}

const searchQuery     = ref('');
const filterGender    = ref('');

const activeTab       = ref('personal');



const tabs = [
  { id: 'personal', icon: UserIcon,    name: 'Informações Pessoais' },
  { id: 'contact',  icon: PhoneIcon,   name: 'Contato'            },
  { id: 'address',  icon: MapPinIcon,  name: 'Endereço'           },
  { id: 'medical',  icon: ActivityIcon,name: 'Informações Médicas'}
];

// — emptyPatient em camelCase para o frontend —
const emptyPatient = {
  id: null,
  name: '',
  socialName: '',
  birthdate: '',
  gender: '',
  race: '',
  documentType: 'CPF',
  documentValue: '',
  cpf: '',
  cns: '',
  phone: '',
  email: '',
  emergencyContact: '',
  address: {
    cep: '',
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    state: '',
    logradouro: '',
    logradouro_codigo: '',
    logradouro_tipo: ''
  },
  stateIbgeCode: '',
  healthInsurance: '',
  insuranceId: '',
  allergies: '',
  medicalConditions: '',
  notes: ''
};

// Função assíncrona para buscar código IBGE da cidade via API do IBGE
async function fetchCityIbgeCode(cityName, stateCode) {
  if (!cityName || !stateCode) return '';
  
  try {
    // Normalizar o nome da cidade (remover acentos, maiúsculas, etc)
    const normalizedCity = cityName.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
    
    // Buscar municípios do estado via API do IBGE
    const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${stateCode}/municipios`);
    const municipalities = await response.json();
    
    // Procurar a cidade pelo nome
    const foundCity = municipalities.find(municipality => 
      municipality.nome.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase() === normalizedCity
    );
    
    return foundCity ? foundCity.id.toString() : '';
  } catch (error) {
    console.error('Erro ao buscar código IBGE:', error);
    return '';
  }
}

// Função para lidar com mudança de estado (async wrapper)
async function onStateChange() {
  await updateIbgeCode();
}

// Função para lidar com mudança de cidade (async wrapper)
async function onCityChange() {
  await updateIbgeCode();
}

// Função para atualizar o código IBGE da cidade
async function updateIbgeCode() {
  const city = currentPatient.value.address.city;
  const state = currentPatient.value.address.state;
  
  if (city && state) {
    currentPatient.value.stateIbgeCode = await fetchCityIbgeCode(city, state);
  } else {
    currentPatient.value.stateIbgeCode = '';
  }
}

// lista reativa de pacientes
const patients = ref([]);
const allPatients = ref([]); // Nova variável para armazenar todos os pacientes
const currentPatient = ref({ ...emptyPatient });
const insurances = ref([]); // Para convênios
const logradouros = ref([]); // Para logradouros
const selectedLogradouroTipo = ref('');

async function lookupCep() {
  let cep = currentPatient.value.address.cep || '';
  // remove tudo que não for dígito
  cep = cep.replace(/\D/g, '');
  if (cep.length !== 8) return;

  isLoadingCep.value = true;
  
  try {
    // Usa o endpoint do backend que consulta a API ViaCEP
    const { data } = await apiClient.get(`/api/v1/schedules/consultar-cep/${cep}/`);
    if (data.success) {
      currentPatient.value.address.street     = data.logradouro || '';
      currentPatient.value.address.neighborhood = data.bairro || '';
      currentPatient.value.address.complement = data.complemento || '';
      currentPatient.value.address.city       = data.localidade || '';
      currentPatient.value.address.state      = data.uf || '';
      await updateIbgeCode(); // Atualizar código IBGE quando a cidade for carregada pelo CEP
      
      // Buscar logradouros específicos para este CEP
      await searchLogradourosByCep();
      
      showBanner('success', 'Endereço encontrado com sucesso!');
    } else {
      console.warn('CEP não encontrado:', data.error);
      showBanner('warning', 'CEP não encontrado. Verifique se o CEP está correto.');
    }
  } catch (e) {
    console.error('Erro ao consultar CEP:', e);
    showBanner('error', 'Erro ao consultar CEP. Verifique se o CEP está correto.');
  } finally {
    isLoadingCep.value = false;
  }
}

// Função para formatar CEP
function formatCep() {
  if (!currentPatient.value.address.cep) return;
  
  // Remove tudo que não for dígito
  let cep = currentPatient.value.address.cep.replace(/\D/g, '');
  
  // Limita a 8 dígitos
  cep = cep.substring(0, 8);
  
  // Aplica a formatação: 00000-000
  if (cep.length <= 5) {
    currentPatient.value.address.cep = cep;
  } else {
    currentPatient.value.address.cep = cep.substring(0, 5) + '-' + cep.substring(5);
  }
}

// Função para lidar com mudança de tipo de logradouro
function onLogradouroTipoChange() {
  if (selectedLogradouroTipo.value) {
    currentPatient.value.address.logradouro_codigo = selectedLogradouroTipo.value;
    
    // Mapear código para descrição
    const logradouroMap = {
      '001': 'Acesso',
      '002': 'Adro',
      '004': 'Alameda',
      '005': 'Alto',
      '007': 'Atalho',
      '008': 'Avenida',
      '009': 'Balneario',
      '010': 'Belvedere',
      '011': 'Beco',
      '012': 'Bloco',
      '013': 'Bosque',
      '014': 'Boulevard',
      '015': 'Baixa',
      '016': 'Cais',
      '017': 'Caminho',
      '019': 'Chapadão',
      '020': 'Conjunto',
      '021': 'Colônia',
      '022': 'Corredor',
      '023': 'Campo',
      '024': 'Córrego',
      '027': 'Desvio',
      '028': 'Distrito',
      '030': 'Escada',
      '031': 'Estrada',
      '032': 'Estação',
      '033': 'Estádio',
      '036': 'Favela',
      '037': 'Fazenda',
      '038': 'Ferrovia',
      '039': 'Fonte',
      '040': 'Feira',
      '043': 'Forte',
      '045': 'Galeria',
      '046': 'Granja',
      '050': 'Ilha',
      '052': 'Jardim',
      '053': 'Ladeira',
      '054': 'Largo',
      '055': 'Lagoa',
      '056': 'Loteamento',
      '059': 'Morro',
      '060': 'Monte',
      '062': 'Paralela',
      '063': 'Passeio',
      '064': 'Pátio',
      '065': 'Praça',
      '067': 'Parada',
      '070': 'Praia',
      '071': 'Prolongamento',
      '072': 'Parque',
      '073': 'Passarela',
      '074': 'Passagem',
      '076': 'Ponte',
      '077': 'Quadra',
      '079': 'Quinta',
      '081': 'Rua',
      '082': 'Ramal',
      '087': 'Recanto',
      '088': 'Retiro',
      '089': 'Reta',
      '090': 'Rodovia',
      '091': 'Retorno',
      '092': 'Sítio',
      '094': 'Servidão',
      '095': 'Setor',
      '096': 'Subida',
      '097': 'Trincheira',
      '098': 'Terminal',
      '099': 'Trevo',
      '100': 'Travessa',
      '101': 'Via',
      '103': 'Viaduto',
      '104': 'Vila',
      '105': 'Viela',
      '106': 'Vale',
      '108': 'Zigue-zague',
      '452': 'Trecho',
      '453': 'Vereda',
      '465': 'Artéria',
      '468': 'Elevada',
      '469': 'Porto',
      '470': 'Balão',
      '471': 'Paradouro',
      '472': 'Área',
      '473': 'Jardinete',
      '474': 'Esplanada',
      '475': 'Quintas',
      '476': 'Rotula',
      '477': 'Marina',
      '478': 'Descida',
      '479': 'Circular',
      '480': 'Unidade',
      '481': 'Chácara',
      '482': 'Rampa',
      '483': 'Ponta',
      '484': 'Via de pedestre',
      '485': 'Condomínio',
      '486': 'Habitacional',
      '487': 'Residencial',
      '495': 'Canal',
      '496': 'Buraco',
      '497': 'Módulo',
      '498': 'Estância',
      '499': 'Lago',
      '500': 'Núcleo',
      '501': 'Aeroporto',
      '502': 'Passagem Subterrânea',
      '503': 'Complexo Viário',
      '504': 'Praça de Esportes',
      '505': 'Via Elevada',
      '506': 'Rotatória',
      '507': '1ª Travessa',
      '508': '2ª Travessa',
      '509': '3ª Travessa',
      '510': '4ª Travessa',
      '511': '5ª Travessa',
      '512': '6ª Travessa',
      '513': '7ª Travessa',
      '514': '8ª Travessa',
      '515': '9ª Travessa',
      '516': '10ª Travessa',
      '517': '11ª Travessa',
      '518': '12ª Travessa',
      '519': '13ª Travessa',
      '520': '14ª Travessa',
      '521': '15ª Travessa',
      '522': '16ª Travessa',
      '523': '1º Alto',
      '524': '2º Alto',
      '525': '3º Alto',
      '526': '4º Alto',
      '527': '5º Alto',
      '528': '1º Beco',
      '529': '2º Beco',
      '530': '3º Beco',
      '531': '4º Beco',
      '532': '5º Beco',
      '533': '1ª Paralela',
      '534': '2ª Paralela',
      '535': '3ª Paralela',
      '536': '4ª Paralela',
      '537': '5ª Paralela',
      '538': '1ª Subida',
      '539': '2ª Subida',
      '540': '3ª Subida',
      '541': '4ª Subida',
      '542': '5ª Subida',
      '543': '6ª Subida',
      '544': '1ª Vila',
      '545': '2ª Vila',
      '546': '3ª Vila',
      '547': '4ª Vila',
      '548': '5ª Vila',
      '549': '1º Parque',
      '550': '2º Parque',
      '551': '3º Parque',
      '552': '1ª Rua',
      '553': '2ª Rua',
      '554': '3ª Rua',
      '555': '4ª Rua',
      '556': '5ª Rua',
      '557': '6ª Rua',
      '558': '7ª Rua',
      '559': '8ª Rua',
      '560': '9ª Rua',
      '561': '10ª Rua',
      '562': '11ª Rua',
      '563': '12ª Rua',
      '564': 'Estacionamento',
      '565': 'Vala',
      '566': 'Rua de Pedestre',
      '567': 'Túnel',
      '568': 'Variante',
      '569': 'Rodo Anel',
      '570': 'Travessa Particular',
      '571': 'Calçada',
      '572': 'Via de Acesso',
      '573': 'Entrada Particular',
      '645': 'Acampamento',
      '646': 'Via Expressa'
    };
    
    currentPatient.value.address.logradouro_tipo = logradouroMap[selectedLogradouroTipo.value] || '';
  }
}

// Função para buscar logradouros
async function searchLogradouros() {
  if (!currentPatient.value.address.city || !currentPatient.value.address.state) {
    showBanner('warning', 'Por favor, preencha cidade e estado antes de buscar logradouros.');
    return;
  }

  try {
    const params = new URLSearchParams({
      state: currentPatient.value.address.state,
      city: currentPatient.value.address.city
    });

    if (currentPatient.value.address.neighborhood) {
      params.append('neighborhood', currentPatient.value.address.neighborhood);
    }

    const { data } = await apiClient.get(`/api/v1/patients/logradouros/?${params.toString()}`);
    logradouros.value = data.logradouros || [];
    
    if (logradouros.value.length === 0) {
      showBanner('info', 'Nenhum logradouro encontrado. Você pode preencher manualmente.');
    }
  } catch (error) {
    console.error('Erro ao buscar logradouros:', error);
    showBanner('error', 'Erro ao buscar logradouros. Você pode preencher manualmente.');
  }
}

// Função para detectar tipo de logradouro a partir do nome da rua
function detectLogradouroType(streetName) {
  if (!streetName) return { codigo: '', tipo: '' };
  
  const upperStreet = streetName.toUpperCase().trim();
  
  // Mapeamento de prefixos para códigosh
  const prefixMap = {
    'RUA': { codigo: '081', tipo: 'Rua' },
    'AVENIDA': { codigo: '010', tipo: 'Avenida' },
    'AV': { codigo: '010', tipo: 'Avenida' },
    'CONJUNTO': { codigo: '015', tipo: 'Conjunto' },
    'CONJ': { codigo: '015', tipo: 'Conjunto' },
    'TRAVESSA': { codigo: '100', tipo: 'Travessa' },
    'TRV': { codigo: '100', tipo: 'Travessa' },
    'PRAÇA': { codigo: '065', tipo: 'Praça' },
    'PC': { codigo: '065', tipo: 'Praça' },
    'ALAMEDA': { codigo: '003', tipo: 'Alameda' },
    'ALM': { codigo: '003', tipo: 'Alameda' },
    'ESTRADA': { codigo: '025', tipo: 'Estrada' },
    'ESTR': { codigo: '025', tipo: 'Estrada' },
    'RODOVIA': { codigo: '090', tipo: 'Rodovia' },
    'BR': { codigo: '090', tipo: 'Rodovia' },
    'VIA': { codigo: '101', tipo: 'Via' },
    'VILA': { codigo: '104', tipo: 'Vila' },
    'VL': { codigo: '104', tipo: 'Vila' },
    'PARQUE': { codigo: '072', tipo: 'Parque' },
    'PQ': { codigo: '072', tipo: 'Parque' },
    'JARDIM': { codigo: '052', tipo: 'Jardim' },
    'JD': { codigo: '052', tipo: 'Jardim' },
    'LARGO': { codigo: '054', tipo: 'Largo' },
    'LGO': { codigo: '054', tipo: 'Largo' },
    'BECO': { codigo: '008', tipo: 'Beco' },
    'BCO': { codigo: '008', tipo: 'Beco' },
    'BLOCO': { codigo: '009', tipo: 'Bloco' },
    'BLO': { codigo: '009', tipo: 'Bloco' },
    'CALÇADA': { codigo: '571', tipo: 'Calçada' },
    'CALC': { codigo: '571', tipo: 'Calçada' },
    'CAMINHO': { codigo: '017', tipo: 'Caminho' },
    'CAM': { codigo: '017', tipo: 'Caminho' },
    'CHÁCARA': { codigo: '481', tipo: 'Chácara' },
    'CHAC': { codigo: '481', tipo: 'Chácara' },
    'ESCADINHA': { codigo: '028', tipo: 'Escadinha' },
    'ESC': { codigo: '028', tipo: 'Escadinha' },
    'FAVELA': { codigo: '036', tipo: 'Favela' },
    'FAV': { codigo: '036', tipo: 'Favela' },
    'FAZENDA': { codigo: '037', tipo: 'Fazenda' },
    'FAZ': { codigo: '037', tipo: 'Fazenda' },
    'GRANJA': { codigo: '046', tipo: 'Granja' },
    'GRJ': { codigo: '046', tipo: 'Granja' },
    'LADEIRA': { codigo: '053', tipo: 'Ladeira' },
    'LAD': { codigo: '053', tipo: 'Ladeira' },
    'LOTEAMENTO': { codigo: '056', tipo: 'Loteamento' },
    'LOT': { codigo: '056', tipo: 'Loteamento' },
    'MORRO': { codigo: '059', tipo: 'Morro' },
    'MRO': { codigo: '059', tipo: 'Morro' },
    'PASSAGEM': { codigo: '074', tipo: 'Passagem' },
    'PAS': { codigo: '074', tipo: 'Passagem' },
    'PRAIA': { codigo: '070', tipo: 'Praia' },
    'PRAI': { codigo: '070', tipo: 'Praia' },
    'QUADRA': { codigo: '077', tipo: 'Quadra' },
    'QD': { codigo: '077', tipo: 'Quadra' },
    'QUINTA': { codigo: '079', tipo: 'Quinta' },
    'QTA': { codigo: '079', tipo: 'Quinta' },
    'RECANTO': { codigo: '087', tipo: 'Recanto' },
    'REC': { codigo: '087', tipo: 'Recanto' },
    'SÍTIO': { codigo: '092', tipo: 'Sítio' },
    'SIT': { codigo: '092', tipo: 'Sítio' },
    'TRILHA': { codigo: '102', tipo: 'Trilha' },
    'TRIL': { codigo: '102', tipo: 'Trilha' },
    'VALE': { codigo: '106', tipo: 'Vale' },
    'VAL': { codigo: '106', tipo: 'Vale' }
  };
  
  // Verifica prefixos
  for (const [prefix, data] of Object.entries(prefixMap)) {
    if (upperStreet.startsWith(prefix)) {
      return data;
    }
  }
  
  // Se não encontrar prefixo, verifica se contém palavras-chave
  const keywordMap = {
    'RUA': { codigo: '081', tipo: 'Rua' },
    'AVENIDA': { codigo: '010', tipo: 'Avenida' },
    'CONJUNTO': { codigo: '015', tipo: 'Conjunto' },
    'TRAVESSA': { codigo: '100', tipo: 'Travessa' },
    'PRAÇA': { codigo: '065', tipo: 'Praça' },
    'ALAMEDA': { codigo: '003', tipo: 'Alameda' },
    'ESTRADA': { codigo: '025', tipo: 'Estrada' },
    'RODOVIA': { codigo: '090', tipo: 'Rodovia' },
    'VIA': { codigo: '101', tipo: 'Via' },
    'VILA': { codigo: '104', tipo: 'Vila' },
    'PARQUE': { codigo: '072', tipo: 'Parque' },
    'JARDIM': { codigo: '052', tipo: 'Jardim' },
    'LARGO': { codigo: '054', tipo: 'Largo' }
  };
  
  for (const [keyword, data] of Object.entries(keywordMap)) {
    if (upperStreet.includes(keyword)) {
      return data;
    }
  }
  
  // Padrão: Rua
  return { codigo: '081', tipo: 'Rua' };
}

// Função para buscar logradouros por CEP
async function searchLogradourosByCep() {
  let cep = currentPatient.value.address.cep || '';
  cep = cep.replace(/\D/g, '');
  
  if (cep.length !== 8) return;

  try {
    const { data } = await apiClient.get(`/api/v1/patients/logradouros/cep/${cep}/`);
    logradouros.value = data.logradouros || [];
    
    if (logradouros.value.length === 1) {
      // Se houver apenas um logradouro, preencher automaticamente
      const logradouro = logradouros.value[0];
      currentPatient.value.address.logradouro = logradouro.logradouro || '';
      currentPatient.value.address.logradouro_codigo = logradouro.codigo || '';
      currentPatient.value.address.logradouro_tipo = logradouro.logradouro_tipo || '';
      currentPatient.value.address.street = logradouro.logradouro || '';
      currentPatient.value.address.neighborhood = logradouro.bairro || '';
      currentPatient.value.address.city = logradouro.cidade || '';
      currentPatient.value.address.state = logradouro.estado || '';
      
      // Detectar tipo de logradouro automaticamente se não vier do backend
      if (!currentPatient.value.address.logradouro_tipo || !currentPatient.value.address.logradouro_codigo) {
        const detectedType = detectLogradouroType(logradouro.logradouro || '');
        currentPatient.value.address.logradouro_codigo = detectedType.codigo;
        currentPatient.value.address.logradouro_tipo = detectedType.tipo;
        selectedLogradouroTipo.value = detectedType.codigo;
      } else {
        selectedLogradouroTipo.value = currentPatient.value.address.logradouro_codigo;
      }
      
      await updateIbgeCode();
    } else if (logradouros.value.length > 1) {
      // Se houver múltiplos logradouros, mostrar opções
      showBanner('info', `${logradouros.value.length} logradouros encontrados. Selecione um.`);
    } else if (data.address) {
      // Fallback: se não houver logradouros mas houver dados de endereço do ViaCEP
      const address = data.address;
      currentPatient.value.address.street = address.street || '';
      currentPatient.value.address.neighborhood = address.neighborhood || '';
      currentPatient.value.address.city = address.city || '';
      currentPatient.value.address.state = address.state || '';
      
      // Detectar tipo de logradouro automaticamente
      const detectedType = detectLogradouroType(address.street || '');
      currentPatient.value.address.logradouro_codigo = detectedType.codigo;
      currentPatient.value.address.logradouro_tipo = detectedType.tipo;
      selectedLogradouroTipo.value = detectedType.codigo;
      
      await updateIbgeCode();
    }
  } catch (error) {
    console.error('Erro ao buscar logradouros por CEP:', error);
    // Fallback para busca por cidade/estado
    await searchLogradouros();
  }
}



// Função para buscar convênios
const fetchInsurances = async () => {
  try {
    const res = await apiClient.get('/api/v1/insurances/list/?page_size=100'); // Rota de planos/convênios
    insurances.value = res.data.results.map(i => ({
      id: i.id,
      name: i.name // Usando 'name' diretamente para o select
    }));
  } catch (err) {
    console.error('Erro ao buscar planos:', err);
    const errorMessage = err.response?.data?.detail || err.response?.data?.message || 'Erro ao carregar convênios';
    showBanner('error', errorMessage);
    // Em caso de erro, deixa a lista vazia para não quebrar a interface
    insurances.value = [];
  }
};


// — Busca e popula a lista no onMounted —
async function fetchPatients(p = 1) {
  try {
    const { data } = await apiClient.get('/api/v1/patients/', {
      params: {
        page: p,
        page_size: pageSize.value,
        search: searchQuery.value || undefined,
        gender: filterGender.value || undefined,

      }
    });
    total.value    = data.total;
    page.value     = data.page;
    patients.value = data.results.map(p => ({
      id:               p.id,
      name:             p.name,
      socialName:       p.social_name,
      birthdate:        p.birthdate,
      gender:           p.gender,
      race:             p.race,
      documentType:     p.document_type || 'CPF',
      documentValue:    p.document_type === 'CPF' ? p.cpf : p.document_type === 'CNS' ? p.cns : `GEN-${p.id.toString().padStart(6, '0')}`,
      cpf:              p.cpf,
      cns:              p.cns,
      phone:            p.phone,
      email:            p.email,
      emergencyContact: p.emergency_contact,
      address: {
        cep:         p.cep,
        street:      p.street,
        number:      p.number,
        complement:  p.complement,
        neighborhood: p.neighborhood,
        city:        p.city,
        state:       p.state,
        logradouro:  p.logradouro || '',
        logradouro_codigo: p.logradouro_codigo || '',
        logradouro_tipo: p.logradouro_tipo || ''
      },
      stateIbgeCode: p.state_ibge_code || '',
      healthInsurance:    p.health_insurance,
      insuranceId:        p.insurance_id,
      allergies:          p.allergies,
      medicalConditions:  p.medical_conditions,
      notes:              p.notes
    }));
  } catch (e) {
    console.error('Erro ao buscar pacientes paginados', e);
    const errorMessage = e.response?.data?.detail || e.response?.data?.message || 'Erro desconhecido';
    showBanner('error', errorMessage);
  }
}

// — Nova função para buscar todos os pacientes —
async function fetchAllPatients() {
  try {
    const { data } = await apiClient.get('/api/v1/patients/', {
      params: { all: true }
    });
    allPatients.value = data.results.map(p => ({
      id:               p.id,
      name:             p.name,
      socialName:       p.social_name,
      birthdate:        p.birthdate,
      gender:           p.gender,
      race:             p.race,
      documentType:     p.document_type || 'CPF',
      documentValue:    p.document_type === 'CPF' ? p.cpf : p.document_type === 'CNS' ? p.cns : `GEN-${p.id.toString().padStart(6, '0')}`,
      cpf:              p.cpf,
      cns:              p.cns,
      phone:            p.phone,
      email:            p.email,
      emergencyContact: p.emergency_contact,
      address: {
        cep:         p.cep,
        street:      p.street,
        number:      p.number,
        complement:  p.complement,
        neighborhood: p.neighborhood,
        city:        p.city,
        state:       p.state,
        logradouro:  p.logradouro || '',
        logradouro_codigo: p.logradouro_codigo || '',
        logradouro_tipo: p.logradouro_tipo || ''
      },
      stateIbgeCode: p.state_ibge_code || '',
      healthInsurance:    p.health_insurance,
      insuranceId:        p.insurance_id,
      allergies:          p.allergies,
      medicalConditions:  p.medical_conditions,
      notes:              p.notes
    }));
  } catch (e) {
    console.error('Erro ao buscar todos os pacientes', e);
    const errorMessage = e.response?.data?.detail || e.response?.data?.message || 'Erro desconhecido';
    showBanner('error', errorMessage);
  }
}



// — Salvar ou atualizar via API —
async function savePatient() {
  if (!isFormValid.value) return;
  
  // Remove formatação do CPF/CNS antes de enviar
  let documentValue = currentPatient.value.documentValue;
  if (currentPatient.value.documentType === 'CPF') {
    documentValue = documentValue.replace(/\D/g, '');
  } else if (currentPatient.value.documentType === 'CNS') {
    documentValue = documentValue.replace(/\D/g, '');
  }
  
  // constroi payload snake_case
  const payload = {
    name:              currentPatient.value.name,
    social_name:       currentPatient.value.socialName,
    birthdate:         currentPatient.value.birthdate,
    gender:            currentPatient.value.gender,
    race:              currentPatient.value.race || null,
    document_type:     currentPatient.value.documentType,
    cpf:               currentPatient.value.documentType === 'CPF' ? documentValue : '',
    cns:               currentPatient.value.documentType === 'CNS' ? documentValue : '',
    phone:             currentPatient.value.phone,
    email:             currentPatient.value.email,
    emergency_contact: currentPatient.value.emergencyContact,
    cep:               currentPatient.value.address.cep.replace(/\D/g, ''),
    street:            currentPatient.value.address.street,
    number:            currentPatient.value.address.number,
    complement:        currentPatient.value.address.complement,
    neighborhood:      currentPatient.value.address.neighborhood,
    city:              currentPatient.value.address.city,
    state:             currentPatient.value.address.state,
    logradouro:        currentPatient.value.address.logradouro,
    logradouro_codigo: currentPatient.value.address.logradouro_codigo,
    logradouro_tipo:   currentPatient.value.address.logradouro_tipo,
    state_ibge_code:   currentPatient.value.stateIbgeCode,
    health_insurance:  currentPatient.value.healthInsurance,
    insurance_id:      currentPatient.value.insuranceId,
    allergies:         currentPatient.value.allergies,
    medical_conditions:currentPatient.value.medicalConditions,
    notes:             currentPatient.value.notes
  };

  try {
    if (editMode.value) {
      await apiClient.put(`/api/v1/patients/${currentPatient.value.id}/`, payload);
    } else {
      await apiClient.post('/api/v1/patients/', payload);
    }
    showBanner('success', editMode.value ? 'Paciente atualizado com sucesso!' : 'Paciente cadastrado com sucesso!');
    
    // Recarrega a lista de pacientes
    await fetchPatients(page.value);
    
    currentView.value = 'list';
  } catch (err) {
    const errorMessage = err.response?.data?.detail || err.response?.data?.message || 'Erro ao salvar paciente';
    showBanner('error', errorMessage);
  }

}

// — Carregar paciente para edição —
async function editPatient(patient) {
  // Carrega os convênios se ainda não foram carregados
  if (insurances.value.length === 0) {
    await fetchInsurances();
  }
  
  try {
    const { data } = await apiClient.get(`/api/v1/patients/${patient.id}/`);
    // mapeia snake_case → camelCase
    currentPatient.value = {
      id:               data.id,
      name:             data.name,
      socialName:       data.social_name,
      birthdate:        data.birthdate,
      gender:           data.gender,
      race:             normalizeRaceValue(data.race),
      documentType:     data.document_type || 'CPF',
      documentValue:    data.document_type === 'CPF' ? data.cpf : data.document_type === 'CNS' ? data.cns : `GEN-${data.id.toString().padStart(6, '0')}`,
      cpf:              data.cpf,
      cns:              data.cns,
      phone:            data.phone,
      email:            data.email,
      emergencyContact: data.emergency_contact,
      address: {
        cep:        data.cep,
        street:     data.street,
        number:     data.number,
        complement: data.complement,
        neighborhood: data.neighborhood,
        city:       data.city,
        state:      data.state,
        logradouro: data.logradouro || '',
        logradouro_codigo: data.logradouro_codigo || '',
        logradouro_tipo: data.logradouro_tipo || ''
      },
      stateIbgeCode: data.state_ibge_code || '',
      healthInsurance:    data.health_insurance,
      insuranceId:        data.insurance_id,
      allergies:          data.allergies,
      medicalConditions:  data.medical_conditions,
      notes:              data.notes
    };
    
    // Aplica formatação ao carregar dados
    formatName();
    formatSocialName();
    formatDocument();
    formatCep();
    
    editMode.value    = true;
    currentView.value = 'form';
  } catch (err) {
    console.error('Erro ao carregar paciente', err);
    const errorMessage = err.response?.data?.detail || err.response?.data?.message || 'Erro desconhecido';
    showBanner('error', errorMessage);
  }
}

// — Excluir paciente —
async function deletePatient() {
  if (!patientToDelete.value) return;
  try {
    await apiClient.delete(`/api/v1/patients/${patientToDelete.value.id}/`);
    showDeleteModal.value = false;
    showBanner('success', 'Paciente excluído com sucesso!');
    
    // Recarrega a lista de pacientes
    await fetchPatients(page.value);
  } catch (err) {
    console.error('Erro ao excluir paciente', err);
    const errorMessage = err.response?.data?.detail || err.response?.data?.message || 'Erro desconhecido';
    showBanner('error', errorMessage);
  }
}

// — Computeds e demais métodos (igual ao seu original) —
const filteredPatients = computed(() => {
  let res = [...patients.value];
  if (searchQuery.value) {
    const q = searchQuery.value.toLowerCase();
    res = res.filter(p =>
      p.name.toLowerCase().includes(q) ||
      String(p.id).includes(q) ||
      p.cpf?.includes(q) ||
      p.cns?.includes(q) ||
      p.documentValue?.includes(q) ||
      p.phone.includes(q) ||
      (p.healthInsurance && p.healthInsurance.toLowerCase().includes(q))
    );
  }
  if (filterGender.value) {
    res = res.filter(p => p.gender === filterGender.value);
  }
  return res;
});

const isDocumentValid = computed(() => {
  const documentType = currentPatient.value.documentType;
  const documentValue = (currentPatient.value.documentValue || '').trim();
  
  if (!documentType || !documentValue) {
    return true; // Não mostra erro se o campo estiver vazio
  }
  
  // Validação específica do CPF
  if (documentType === 'CPF') {
    const cpfDigits = documentValue.replace(/\D/g, '');
    if (cpfDigits.length !== 11) {
      return false;
    }
    return validateCpf(cpfDigits);
  }
  
  // Validação do CNS (deve ter 15 dígitos)
  if (documentType === 'CNS') {
    const cnsDigits = documentValue.replace(/\D/g, '');
    return cnsDigits.length === 15;
  }
  
  // Tipo genérico sempre é válido
  if (documentType === 'GEN') {
    return true;
  }
  
  return true;
});

const isFormValid = computed(() => {
  const name = (currentPatient.value.name || '').trim();
  const birthdate = currentPatient.value.birthdate;
  const gender = currentPatient.value.gender;
  const documentType = currentPatient.value.documentType;
  const documentValue = (currentPatient.value.documentValue || '').trim();
  const phone = (currentPatient.value.phone || '').trim();
  
  // Validação básica dos campos obrigatórios
  if (!name || !birthdate || !gender || !documentType || !phone) {
    return false;
  }
  
  // Para tipo genérico, não precisa validar o valor do documento
  if (documentType === 'GEN') {
    return true;
  }
  
  // Para outros tipos, o valor do documento é obrigatório
  if (!documentValue) {
    return false;
  }
  
  // Validação específica do CPF
  if (documentType === 'CPF') {
    const cpfDigits = documentValue.replace(/\D/g, '');
    if (cpfDigits.length !== 11) {
      return false;
    }
    return validateCpf(cpfDigits);
  }
  
  // Validação do CNS (deve ter 15 dígitos)
  if (documentType === 'CNS') {
    const cnsDigits = documentValue.replace(/\D/g, '');
    return cnsDigits.length === 15;
  }
  
  return true;
});

// Funções auxiliares (getInitials, getPatientColor, formatDate etc.) — mantidas iguais.

// — Navegação de views e formulários —
function getInitials(name) {
  if (!name) return ''
  return name
    .split(' ')
    .map(w => w[0]?.toUpperCase() || '')
    .join('')
    .substring(0, 2)
}
function getPatientColor(id) {
  const colors = [
    '#10b981', '#3b82f6', '#8b5cf6',
    '#ec4899', '#f59e0b', '#06b6d4',
    '#84cc16'
  ]
  const num = parseInt(String(id).replace(/\D/g, ''), 10) || 0
  return colors[num % colors.length]
}

/**
 * Converte o código de gênero em label
 */
function getGenderLabel(gender) {
  return {
    M: 'Masculino',
    F: 'Feminino',
    O: 'Outro'
  }[gender] || ''
}

/**
 * Formata 'YYYY-MM-DD' em 'DD/MM/YYYY'
 */
function formatDate(dateString) {
  if (!dateString) return ''
  // Parse manual para evitar problemas de timezone
  const [year, month, day] = dateString.split('-')
  if (!year || !month || !day) return ''
  return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
}

async function openNewPatientForm() {
  // Carrega os convênios se ainda não foram carregados
  if (insurances.value.length === 0) {
    await fetchInsurances();
  }
  
  currentPatient.value = { ...emptyPatient };
  editMode.value       = false;
  activeTab.value      = 'personal';
  currentView.value    = 'form';
}
function goToList() {
  currentView.value = 'list';
}
function confirmDeletePatient(p) {
  patientToDelete.value = p;
  showDeleteModal.value = true;
}
function showBanner(type, message) {
  // Formata a mensagem para melhor apresentação
  let formattedMessage = message;
  
  // Se a mensagem vier do backend com detalhes, formata melhor
  if (typeof message === 'string' && message.includes('detail')) {
    // Remove prefixos comuns de erro do backend
    formattedMessage = message
      .replace(/^Erro ao .*?: /, '')
      .replace(/^Ocorreu um erro ao .*?: /, '')
      .replace(/^Erro: /, '')
      .replace(/^Erro desconhecido$/, 'Ocorreu um erro inesperado. Tente novamente.');
  }
  
  // Capitaliza a primeira letra se necessário
  if (formattedMessage && formattedMessage.length > 0) {
    formattedMessage = formattedMessage.charAt(0).toUpperCase() + formattedMessage.slice(1);
  }
  
  banner.value = { show: true, type, message: formattedMessage };
}
function resetFilters() {
  searchQuery.value  = '';
  filterGender.value = '';
}
watch([searchQuery, filterGender, pageSize], () => {
  fetchPatients(1);
});



// — Lifecycle Hook —
onMounted(() => {
  fetchPatients();
});

function goPrev() {
  if (page.value > 1) {
    fetchPatients(page.value - 1);
  }
}

function goNext() {
  if (page.value < totalPages.value) {
    fetchPatients(page.value + 1);
  }
}

// Função para lidar com mudança no tipo de documento
function onDocumentTypeChange() {
  // Limpa o valor do documento quando muda o tipo
  currentPatient.value.documentValue = '';
  currentPatient.value.cpf = '';
  currentPatient.value.cns = '';
  
  // Se for genérico, gera o identificador automaticamente
  if (currentPatient.value.documentType === 'GEN' && currentPatient.value.id) {
    currentPatient.value.documentValue = `GEN-${currentPatient.value.id.toString().padStart(6, '0')}`;
  }
}

// Função para formatar nome em maiúsculas
function formatName() {
  if (currentPatient.value.name) {
    currentPatient.value.name = currentPatient.value.name.toUpperCase();
  }
}

// Função para formatar nome social em maiúsculas
function formatSocialName() {
  if (currentPatient.value.socialName) {
    currentPatient.value.socialName = currentPatient.value.socialName.toUpperCase();
  }
}

// Função para obter o label da raça
function getRaceLabel(raceCode) {
  const raceMap = {
    '01': 'Branca',
    '02': 'Preta',
    '03': 'Parda',
    '04': 'Amarela',
    '05': 'Indígena',
    '99': 'Sem informação'
  };
  return raceMap[raceCode] || (raceCode || 'Não informada');
}

// Função para normalizar o valor da raça (texto completo -> código)
function normalizeRaceValue(raceValue) {
  if (!raceValue) return '';
  
  const raceReverseMap = {
    'branca': '01',
    'preta': '02',
    'parda': '03',
    'amarela': '04',
    'indígena': '05',
    'sem informação': '99'
  };
  
  const normalizedValue = raceValue.toLowerCase().trim();
  return raceReverseMap[normalizedValue] || raceValue;
}

// Função para validar CPF
function validateCpf(cpf) {
  // Remove caracteres não numéricos
  cpf = cpf.replace(/\D/g, '');
  
  // Verifica se tem 11 dígitos
  if (cpf.length !== 11) return false;
  
  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cpf)) return false;
  
  // Validação do primeiro dígito verificador
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let remainder = sum % 11;
  let digit1 = remainder < 2 ? 0 : 11 - remainder;
  
  if (parseInt(cpf.charAt(9)) !== digit1) return false;
  
  // Validação do segundo dígito verificador
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i);
  }
  remainder = sum % 11;
  let digit2 = remainder < 2 ? 0 : 11 - remainder;
  
  return parseInt(cpf.charAt(10)) === digit2;
}

// Função para formatar CPF ou CNS
function formatDocument() {
  if (!currentPatient.value.documentValue) return;
  
  if (currentPatient.value.documentType === 'CPF') {
    // Remove tudo que não for dígito
    let cpf = currentPatient.value.documentValue.replace(/\D/g, '');
    
    // Limita a 11 dígitos
    cpf = cpf.substring(0, 11);
    
    // Aplica a formatação: XXX.XXX.XXX-XX
    if (cpf.length <= 3) {
      currentPatient.value.documentValue = cpf;
    } else if (cpf.length <= 6) {
      currentPatient.value.documentValue = cpf.substring(0, 3) + '.' + cpf.substring(3);
    } else if (cpf.length <= 9) {
      currentPatient.value.documentValue = cpf.substring(0, 3) + '.' + cpf.substring(3, 6) + '.' + cpf.substring(6);
    } else {
      currentPatient.value.documentValue = cpf.substring(0, 3) + '.' + cpf.substring(3, 6) + '.' + cpf.substring(6, 9) + '-' + cpf.substring(9);
    }
    
    // Valida CPF quando tem 11 dígitos
    if (cpf.length === 11) {
      const isValid = validateCpf(cpf);
      if (!isValid) {
        showBanner('warning', 'CPF inválido. Verifique os números digitados.');
      }
    }
  } else if (currentPatient.value.documentType === 'CNS') {
    // Remove tudo que não for dígito
    let cns = currentPatient.value.documentValue.replace(/\D/g, '');
    
    // Limita a 15 dígitos
    cns = cns.substring(0, 15);
    
    // Aplica a formatação: XXX XXXX XXXX XXXX
    if (cns.length <= 3) {
      currentPatient.value.documentValue = cns;
    } else if (cns.length <= 7) {
      currentPatient.value.documentValue = cns.substring(0, 3) + ' ' + cns.substring(3);
    } else if (cns.length <= 11) {
      currentPatient.value.documentValue = cns.substring(0, 3) + ' ' + cns.substring(3, 7) + ' ' + cns.substring(7);
    } else {
      currentPatient.value.documentValue = cns.substring(0, 3) + ' ' + cns.substring(3, 7) + ' ' + cns.substring(7, 11) + ' ' + cns.substring(11);
    }
  } else if (currentPatient.value.documentType === 'GEN') {
    // Para tipo genérico, não aplica formatação, apenas garante que está no formato correto
    if (currentPatient.value.id && !currentPatient.value.documentValue.startsWith('GEN-')) {
      currentPatient.value.documentValue = `GEN-${currentPatient.value.id.toString().padStart(6, '0')}`;
    }
  }
}

// Watch para sincronizar selectedLogradouroTipo com logradouro_codigo
watch(() => currentPatient.value.address.logradouro_codigo, (newValue) => {
  selectedLogradouroTipo.value = newValue || '';
});

// Função para sincronizar um paciente individual
async function syncPatient(patient) {
  console.log(`🔄 [FRONTEND] Iniciando sincronização do paciente:`, patient);
  console.log(`📤 [FRONTEND] Enviando requisição para: api/v1/patients/${patient.id}/resync/`);
  
  try {
    const response = await apiClient.post(`/api/v1/patients/${patient.id}/resync/`);
    console.log(`📥 [FRONTEND] Resposta recebida:`, response.data);
    
    if (response.data.success) {
      console.log(`✅ [FRONTEND] Paciente ${patient.name} sincronizado com sucesso!`);
      showBanner('success', `Paciente "${patient.name}" sincronizado com sucesso!`);
    } else {
      console.log(`❌ [FRONTEND] Falha na sincronização:`, response.data.message);
      showBanner('error', response.data.message || 'Erro ao sincronizar paciente');
    }
  } catch (error) {
    console.error('❌ [FRONTEND] Erro ao sincronizar paciente:', error);
    console.error('📋 [FRONTEND] Detalhes do erro:', {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    const errorMessage = error.response?.data?.message || error.response?.data?.detail || 'Erro ao sincronizar paciente';
    showBanner('error', errorMessage);
  }
}

// Função para sincronizar todos os pacientes
/*async function syncAllPatients() {
  if (isSyncingAll.value) return;
  
  console.log(`🔄 [FRONTEND] Iniciando sincronização de TODOS os pacientes`);
  console.log(`📤 [FRONTEND] Enviando requisição para: api/v1/patients/resync-all/`);
  
  isSyncingAll.value = true;
  try {
    const response = await apiClient.post('/api/v1/patients/resync-all/');
    console.log(`📥 [FRONTEND] Resposta recebida:`, response.data);
    
    if (response.data.success) {
      console.log(`✅ [FRONTEND] Todos os pacientes sincronizados com sucesso!`);
      showBanner('success', response.data.message || 'Todos os pacientes foram sincronizados com sucesso!');
    } else {
      console.log(`❌ [FRONTEND] Falha na sincronização de todos:`, response.data.message);
      showBanner('error', response.data.message || 'Erro ao sincronizar todos os pacientes');
    }
  } catch (error) {
    console.error('❌ [FRONTEND] Erro ao sincronizar todos os pacientes:', error);
    console.error('📋 [FRONTEND] Detalhes do erro:', {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    const errorMessage = error.response?.data?.message || error.response?.data?.detail || 'Erro ao sincronizar todos os pacientes';
    showBanner('error', errorMessage);
  } finally {
    isSyncingAll.value = false;
    console.log(`🏁 [FRONTEND] Sincronização finalizada`);
  }
}*/

// Função para resetar senha do portal
async function resetPortalPassword(patient) {
  console.log(`🔐 [FRONTEND] Iniciando reset de senha do portal para paciente:`, patient);
  console.log(`📤 [FRONTEND] Enviando requisição para: api/v1/patients/${patient.id}/reset-portal-password/`);
  
  try {
    const response = await apiClient.post(`/api/v1/patients/${patient.id}/reset-portal-password/`);
    console.log(`📥 [FRONTEND] Resposta recebida:`, response.data);
    
    if (response.data.success) {
      console.log(`✅ [FRONTEND] Senha do portal resetada para paciente ${patient.name}!`);
      showBanner('success', response.data.message || `Senha do portal resetada para "${patient.name}"!`);
    } else {
      console.log(`❌ [FRONTEND] Falha no reset de senha:`, response.data.message);
      showBanner('error', response.data.message || 'Erro ao resetar senha do portal');
    }
  } catch (error) {
    console.error('❌ [FRONTEND] Erro ao resetar senha do portal:', error);
    console.error('📋 [FRONTEND] Detalhes do erro:', {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    const errorMessage = error.response?.data?.message || error.response?.data?.detail || 'Erro ao resetar senha do portal';
    showBanner('error', errorMessage);
  }
}



</script>

<style>
.clinic-btn {
  background-color: var(--clinic-btn-bg) !important;
  color: #fff !important;
  transition: background 0.2s;
}
.clinic-btn:hover {
  background-color: var(--clinic-btn-bg-hover) !important;
}
.input-font-color, input, select, textarea {
  color: var(--clinic-font-color) !important;
}

/* Patient Merge Modal Styles */
.merge-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Patient Select Styles */
.merge-modal select {
  font-family: inherit;
  line-height: 1.4;
}

.merge-modal select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.merge-modal-content {
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
}

.merge-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
}

.merge-modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #333;
}

.merge-section {
  margin-bottom: 24px;
}

.merge-section h3 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #333;
}

.search-container {
  position: relative;
  margin-bottom: 12px;
}

.search-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
}

.search-result-item {
  padding: 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}

.search-result-item:hover {
  background-color: #f8f9fa;
}

.search-result-item:last-child {
  border-bottom: none;
}

.patient-info {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 12px;
  margin-top: 8px;
}

.patient-info h4 {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.patient-info p {
  margin: 4px 0;
  font-size: 13px;
  color: #666;
}

.warning-section {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 16px;
  margin: 20px 0;
}

.warning-section h4 {
  color: #856404;
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
}

.warning-section p {
  color: #856404;
  margin: 0;
  font-size: 14px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

.btn-cancel {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-cancel:hover {
  background-color: #5a6268;
}

.btn-confirm {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-confirm:hover {
  background-color: #c82333;
}

.btn-confirm:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.merge-btn {
  background-color: #28a745 !important;
}

.merge-btn:hover {
  background-color: #218838 !important;
}
</style>
